import styled from '@emotion/styled'

export const Image = styled('img')`
  max-height: 200px;
  margin-bottom: 44px;
  @media only screen and (max-width: ${({ theme }) => theme.screenXL + 300}px) {
    margin-bottom: 37px;
  }
`
